import React, { FC } from 'react';
import { BiCheck, BiX } from 'react-icons/bi';

import ButtonDefault, {
  ButtonVariants,
} from '@/components/shared/basic/button';
import { ShouldRender } from '@/components/shared/basic/ShouldRender';

export type IList = { check: boolean; title: string }[];
interface Props {
  list: IList;
  price: string;
  title: string;
  valueForMoney: boolean;
  durationText: string;
  redirectUrl?: string;
}

const PriceContainer: FC<Props> = ({
  list,
  price,
  title,
  valueForMoney,
  durationText,
  redirectUrl,
}) => {
  return (
    <div className='relative border border-white px-6 py-7 rounded-2xl bg-stroke min-w-[342px] md:w-auto w-full'>
      <ShouldRender check={valueForMoney}>
        <div className='flex justify-center absolute -top-4 left-0 w-full'>
          <div className='inline-block rounded-[10px] p-[1px] bg-gradient-to-t from-[#FFF069] to-[#26AE00]'>
            <button className='px-3 py-1 rounded-[10px] bg-gradient-to-t from-[#24240f] to-[#091B02]'>
              <span className='text-xs text-transparent bg-clip-text bg-gradient-to-t from-[#FFF069] to-[#26AE00] font-semibold'>
                % Value For Money
              </span>
            </button>
          </div>
        </div>
      </ShouldRender>

      <p className='text-white font-semibold text-base mb-6'>{title}</p>
      <p className='text-xl text-grayZl-500 mb-6 font-semibold'>
        <span className='text-white'>₹ {price}</span> {durationText}
      </p>
      <ButtonDefault
        onClick={() => {
          if (typeof window !== 'undefined') {
            const targetUrl = redirectUrl || 'https://zbrlrn.com/9Xvat';
            if (targetUrl) {
              window.open(targetUrl, '_blank');
            }
          }
        }}
        variant={ButtonVariants.PRIMARY}
        size={0}
        className='p-2.5 w-full text-sm  font-semibold mb-6'
      >
        Select
      </ButtonDefault>
      <div className='bg-grayZl-850 h-px w-full mb-6'></div>
      <div>
        <p className='text-grayZl-600 text-sm font-medium mb-2'>
          What is inside :
        </p>
        <div className='space-y-2'>
          {list.map((i, index) => (
            <div key={index} className='flex items-center gap-2'>
              {i.check ? (
                <BiCheck className='w-6 h-6 text-success-400' />
              ) : (
                <BiX className='w-6 h-6 text-error-600' />
              )}

              <p className='font-normal text-white text-sm'>{i.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PriceContainer;
